import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mg-ellipsis',
  templateUrl: './MgEllipsis.element.html',
  styleUrls: ['./MgEllipsis.element.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MgEllipsisElement {}
